import { render } from "./RoundButton.vue?vue&type=template&id=74206fc2&scoped=true"
import script from "./RoundButton.vue?vue&type=script&lang=js"
export * from "./RoundButton.vue?vue&type=script&lang=js"

import "./RoundButton.vue?vue&type=style&index=0&id=74206fc2&lang=sass&scoped=true"

import exportComponent from "../../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74206fc2"]])

export default __exports__